import { Dialog, DialogContent, LinearProgress, Typography } from '@mui/material';

type ImportProgressModalType = {
	open: boolean;
	progress: number | null;
};

const styles = {
	progressBar: {
		height: 8,
		borderRadius: 4,
	},
};

export const ImportProgressModal = ({ open, progress }: ImportProgressModalType) => (
	<Dialog open={open}>
		<DialogContent sx={{ p: 3, textAlign: 'center' }}>
			<Typography mb={2} sx={{ maxWidth: '400px' }}>
				{"Please don't close this window while we're importing your users..."}
			</Typography>
			<LinearProgress
				variant="determinate"
				value={progress as number}
				sx={styles.progressBar}
			/>
			<Typography mt={2}>{progress}%</Typography>
		</DialogContent>
	</Dialog>
);
